module.exports = __webpack_public_path__ + "img/banner-bg_2.7e78aa74.png";